import React, { Component } from 'react';

import Header from '../components/header/Header';
import StoreBanner from '../components/store-banner/StoreBanner';
import Auth from '../components/auth/Auth';
import Footer from '../components/footer/Footer';
import Addresses from '../components/addresses/Addresses';
import Checkout from '../components/checkout/Checkout';
import Cart from '../components/cart/Cart';
import landingService from '../services/landing.service';
import couponService from '../services/coupon.service';
import Success from '../components/pages/Success';
import userService from '../services/user.service';
import ProductList from '../components/product-list/ProductList';
import OrderSchedule from '../components/order-schedule/OrderSchedule';
import orderService from '../services/order.service';
import ENV from '../environments/environment'

declare var $;

class Store extends Component {

  constructor(props) {
      super(props);
      this.state = {
        dataCoupon: [],
        loading: true,
        logued: false,
        addressSelected: false,
        selectedAddress: [],
        error: '',
        couponData: [],
        userData: [],
        products: [],
        selectedProducts: false,
        showCallto: true,
        styleCart: 'slideOutDown',
        partialTotal: 0,
        partialQuantity: 0,
        landingData: [],
        step: 1,
        auth: false,
        store_id: 0,
        cart: false
      };
      this.logout = this.logout.bind(this);
      this.stepBack = this.stepBack.bind(this);
      this.getUserData = this.getUserData.bind(this);
      this.handleSelectedProducts = this.handleSelectedProducts.bind(this);
      this.getStoreData = this.getStoreData.bind(this);
      this.setCartBarInteraction = this.setCartBarInteraction.bind(this);
      this.handlePartiallySelectedProducts = this.handlePartiallySelectedProducts.bind(this);
      this.getShippingCharges =   this.getShippingCharges.bind(this)
      this.handleCart = this.handleCart.bind(this)
    }

  componentWillMount() {
     this.getStoreData()
  }

  componentDidMount() {
    this.setCartBarInteraction()
  }

  async getStoreData() {
    let products_id = this.props.match.params.products_id.split("_")
    let coords = this.props.match.params.coords.split("_")
    let query = this.props.match.params.query;
    localStorage.setItem('country', this.props.match.params.country)
    let response = await landingService.getProducts(products_id, coords, query)
    response = response.data;
    let products = response.products;
    let store_id = response.store_id
    if(products) {
       if (this.props.match.params.token) {
          localStorage.setItem('accessToken', this.props.match.params.token);
       }
      let userData = [];
      this.setState({
        products,
        landingData: response,
        store_id
      })
    }
  }

  handleAuth(e) {
    this.getUserData()
  }

async handleSelectedAddress(address) {
     this.setState({
       selectedAddress: address,
       error: ''
    })
    this.getShippingCharges(address.lng, address.lat);
    if(this.props.match.params.coupon_code) {
    let coupon = {
     coupon: {
       code: this.props.match.params.coupon_code,
       lng: address.lng,
       lat: address.lat,
       purchase_type: "now",
       token: localStorage.getItem('accessToken')
     }
   }
     let response = await couponService.redeemCoupon(coupon)
     if(!response.message_error) {
        response = response.data;
        response.coupon_code = this.props.match.params.coupon_code;
        response.cc_only = this.state.dataCoupon.cc_only
        let products = JSON.parse(localStorage.getItem('products'))
        if(products) {
          response.products = products
        }
       this.setState({
         couponData: response,
         addressSelected: true
       })
     } else {
       this.setState({
         error: response.message_error
       })
     }
   } else {
     let response = [];
     let products = JSON.parse(localStorage.getItem('products'))
     if(products) {
       response.products = products
     }
     let step = this.state.step;
     step++;
     this.setState({
       couponData: response,
       addressSelected: true,
       step
     })
   }
  }

  async getShippingCharges(lng,lat) {
    let response = await orderService.getShippingCharges(lat ,lng)
    response = response.data;
    let  shippingCharge = response[this.props.match.params.query];
    let shippingValue = shippingCharge[0].value;
    this.setState({
      shippingValue
    })
  }

  async getUserData() {
    localStorage.setItem('accessToken', this.props.match.params.token)
    let response = [];
    response = await userService.getUserData();
    let step = this.state.step;
    step++
    this.setState({
      userData: response,
      logued: true,
      step
    })
  }

  logout() {
    this.setState({
      logued: false,
      addressSelected: false
    })
    localStorage.removeItem('accessToken')
  }

  stepBack() {
    this.setState({
      addressSelected: false
    })
  }

  setAuthScreen(auth) {
    this.setState({
      auth
    })
  }

  nextStep(step) {
    if(step != 3 || localStorage.getItem('user_data')) {
     this.setState({
       step
     })
   } else {
     this.getUserData(step)
   }
  }

  handleSelectedProducts(selectedProducts) {
     selectedProducts =  JSON.parse(JSON.stringify(selectedProducts))
      for(let product of selectedProducts) {
        product.image = ENV.getImageUrl() + product.image;
      }
     this.setState({
       selectedProducts
     })
     localStorage.setItem('products', JSON.stringify(selectedProducts))
     this.getUserData()
  }

  setCartBarInteraction( ) {
    let $win = $(window);
    let winH = $win.height();
    $win.on("scroll", () => {
       if ($win.scrollTop() > 200 ) {
           this.setState({
             styleCart: 'slideInUp'
           })
       } else {
         this.setState({
           showCallto: true,
           styleCart: 'slideOutDown'
         })
       }
   })
  }

  handlePartiallySelectedProducts(data) {
    let partialTotal = data.total;
    let partialQuantity = data.quantity;
    this.setState({
      partialTotal,
      partialQuantity
    })
  }

  handleCart(e) {
    this.setState({
      cart: e
    })
  }

  render() {
    return (
        <div className="store">
          <div className="content-wrapper">
      { (this.state.step === 1 && !this.state.cart) &&
        <div>
        <StoreBanner coupon_code={this.props.match.params.coupon_code}  copy={this.props.match.params.copy} subcopy={this.props.match.params.subcopy}></StoreBanner>
        <section>
        <ProductList  store_id={this.state.store_id} partiallySelectedProducts={this.handlePartiallySelectedProducts.bind(this)}  selected={this.handleSelectedProducts.bind(this)} products={this.state.products}/>
        </section>
        { !this.state.landingData.products && <h3 className="text-center unavaliable">Ups, no hay productos disponibles :(</h3>}
        </div>
        }

      { (this.state.step === 2 && !this.state.cart)  && <Addresses cart={this.handleCart.bind(this)} step={this.state.step} continue={this.nextStep.bind(this)} auth="true" userData={this.state.userData} error={this.state.error} setSelectedAddress={this.handleSelectedAddress.bind(this)}></Addresses> }
      { (this.state.step === 3 && !this.state.cart) && <Checkout cart={this.handleCart.bind(this)} step={this.state.step}  showProducts="false"  step={this.state.step} continue={this.nextStep.bind(this)} selectedAddress={this.state.selectedAddress} couponData={this.state.couponData}></Checkout> }
      { (this.state.step === 4 && !this.state.cart) && <Success></Success> }

      { this.state.cart && <Cart cart={this.handleCart.bind(this)}></Cart> }

          </div>
        </div>
    );
  }
}




export default Store;



// WEBPACK FOOTER //
// ./src/modules/Store.js